export const statsData = [
  {
    title: "Projects Completed",
    describe: "150+",
  },
  {
    title: "Years of Experience",
    describe: "3.5+",
  },
  {
    title: "lines of code",
    describe: "100,000+",
  },
];
